// Shared design tokens and layout constants for the ai-chat panel.

export const D = {
	bg: '#ffffff',
	surface: '#f8f7fb',
	surface2: '#f0ecfa',
	border: '#e9e9e9',
	borderFocus: '#6E0FEB',
	textPrimary: '#2e2541',
	textSecondary: '#535353',
	textMuted: '#8c8c8c',
	textDisabled: '#acacb9',
	accent: '#392664',
	accentMid: '#6E0FEB',
	accentHover: '#f0ecfa',
	userBubble: '#f0ecfa',
	userBubbleBorder: '#ddd5f5',
	assistantBubble: '#ffffff',
	assistantBubbleBorder: '#e9e9e9',
	inputBg: '#ffffff',
	inputBorder: '#d3d3df',
	stepDoneBg: '#f0fdf4',
	stepDoneBorder: '#86efac',
	stepDoneText: '#15803d',
	stepActiveBg: '#f0ecfa',
	stepActiveBorder: '#c4b5fd',
	stepActiveText: '#6d28d9',
	stepIdleBg: '#f9fafb',
	stepIdleBorder: '#e5e7eb',
	stepIdleText: '#6b7280',
	stepIdleDot: '#d1d5db',
	errorBg: '#fef2f2',
	errorBorder: '#fca5a5',
	errorText: '#e23f3f',
};

export const TRUNCATE_AT = 1200;
export const PREVIEW_CHARS = 800;
export const MIN_WIDTH = 340;
export const MAX_WIDTH = 860;
export const DEFAULT_WIDTH = 560;
export const CARD_BOTTOM = 80;
